// /**
//  * Parcel - Add
//  */

// React
import React, { useEffect, useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import {
    TextField,
    Grid,
    Button,
    Paper,
    Typography,
    DialogContent,
    DialogActions,
    Dialog,
    Divider,
} from '@material-ui/core';

import classes from './add.module.scss';
import tokenRepository from 'client-sdk/src/Repository/token-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

type Props = {
    create: (body: any) => void;
    onClose: () => void;
    warehouseId: number;
    createParcelsDispatch: (payload: any) => void;
};

type Inputs = {
    basalamUrl: string;
};

function TokenManagement(props: Props) {
    const { search } = useLocation()
    const history = useHistory();
    const { register, handleSubmit, watch, setValue, getValues } = useForm<Inputs>({
        defaultValues: {
            basalamUrl: '',
        },
    });
    const [tab, setTab] = useState(2)
    const [shopInfo, setShopInfo] = useState({})
    const code = queryString.parse(search).code

    useEffect(() => {
        if (code) {
            basalamTokenRegister()
        } else {
            getPartnerBasalamToken()
        }
    }, [])
    //Aryan
    const [isBoothVerified, setIsBootVerified] = useState<boolean>(false);

    const [isSessionAuthenticated, setIsSessionAuthenticated] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onSubmit = (data: Inputs) => {

    };

    const submitBasalamShop = (redirectUrl: string) => {
        window.location.replace(redirectUrl)
    }

    const initBasalamOAuth = async () => {
        try {
            const response = await tokenRepository.InitializeBasalamOAuth()
            submitBasalamShop(response.data)
        } catch (error) {
            handleError(error)
        }
    }

    const getPartnerBasalamToken = async () => {
        try {
            const response = await tokenRepository.getShopInfo()
            setShopInfo(response.data)
            response?.data?.basalamPartnerInfo?.basalamPartnerUrl && setValue("basalamUrl", response?.data?.basalamPartnerInfo?.basalamPartnerUrl)
        } catch (error) {
            // handleError(error)
        }
    }

    const registerBasalamUrl = async () => {
        try {
            const response = await tokenRepository.RegisterShopUrl({ payload: { basalamPartnerUrl: getValues("basalamUrl") } })
            setShopInfo(response.data)
            handleNotfication("آدرس غرفه شما ذخیره شد لطفا مراحل احراز هویت را انجام دهید.", "success")
        } catch (error) {
            handleError(error)
        }
    }

    const buttonFunctionBuilder = () => {
        if (shopInfo?.basalamPartnerInfo?.basalamPartnerUrl) {
            return initBasalamOAuth
        }
        return registerBasalamUrl
    }

    const buttonLabelBuilder = () => {
        if (shopInfo?.basalamPartnerInfo?.basalamPartnerUrl) {
            return "احراز هویت"
        }
        return "تایید"
    }

    const basalamTokenRegister = async () => {
        try {
            const response = await tokenRepository.RegisterBasalamToken({ payload: { code } })
            setShopInfo(response.data)
            setValue("basalamUrl", response.data?.basalamPartnerInfo?.basalamPartnerUrl)
            handleNotfication("احراز هویت شما با موفقیت انجام شد.", "success")
            history.replace("/integration")
        } catch (error) {
            handleError(error)
        }
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                توکن‌ها
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.formWrapper}>
                <ul className={classes.tabContainer}>
                    <li className={classes.tabItems + " " + (tab == 1 && classes.active)}>دریافت توکن</li>
                    <li onClick={() => setTab(2)} className={classes.tabItems + " " + (tab == 2 && classes.active)}>افزودن توکن</li>
                </ul>
                {tab == 2 && <Grid container justifyContent='space-between' style={{ marginTop: "70px" }}>
                    <Grid item lg={6}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <label htmlFor="basalamUrl" style={{ marginLeft: "16px", width: "150px" }}>آدرس غرفه با‌سلام</label>
                            <div style={{ display: "flex", width: "100%" }}>
                                <div className='TextField-without-border-radius' style={{ width: "100%" }}>
                                    <TextField
                                        fullWidth
                                        dir='ltr'
                                        placeholder='example'
                                        variant='outlined'
                                        id='basalamUrl'
                                        name='basalamUrl'
                                        inputRef={register({ required: true })}
                                        disabled={shopInfo?.basalamPartnerInfo?.basalamPartnerUrl}
                                    />
                                </div>
                                <Button
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    disabled={shopInfo?.active}
                                    style={{ borderRadius: "4px 0 0 4px", width: "20%" }}
                                    onClick={buttonFunctionBuilder()}
                                >{buttonLabelBuilder()}</Button>
                            </div>
                        </div>
                    </Grid>
                </Grid>}
                {/* <Grid
                    container
                    justifyContent='flex-end'
                >
                    <Button
                        type="submit"
                        size="medium"
                        data-cy="saveBtn"
                        variant="contained"
                        color="primary"
                        disabled={
                            Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                                .length === 0
                        }
                    >
                        ویرایش
                    </Button>
                </Grid> */}
            </form>
            <Dialog
                open={false}
                fullWidth
                // onClose={}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    {/* <div
                        style={{
                            position: 'absolute',
                            left: '3px',
                            top: '10px',
                            zIndex: 10,
                        }}
                    >
                        {handleClose ? (
                            <IconButton aria-label="close" onClick={handleClose}>
                                <Icon path={mdiClose} size={1} />
                            </IconButton>
                        ) : null}
                    </div>

                    <div
                        className={classes.cancelTitle}
                    >{`آیا از حذف ${itemDeleted.name} از محموله اطمینان دارید؟`}</div> */}
                    <Divider style={{ width: '100%', margin: '16px 0  0' }} />
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    {/* <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        style={{ textAlign: 'center', marginBottom: '8px' }}
                    >
                        <Grid item xs={12}>
                            <Button
                                style={{ margin: '8px' }}
                                autoFocus
                                onClick={handleClose}
                                variant="outlined"
                                color="primary"
                                size="large"
                                data-cy="cancelRemove"
                            >
                                {'انصراف'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={deleteItemsToParcels}
                                size="large"
                                data-cy="confirmRemove"
                                color="primary"
                            >
                                {'حذف کالا'}
                            </Button>
                        </Grid>
                    </Grid> */}
                </DialogActions>
            </Dialog>
        </>
    );
}

export default TokenManagement;
